import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import {
  CarouselCss,
  CarouselPopupBackground,
  CarouselPopupContainer,
  CarouselPopupCover,
  CrossWhite,
} from '../PdpCarousel/styled';
import UserDetailImagesByUser from '../UserDetailImagesByUser';
import { images } from '../../../Constants/ImageUrls';
import { getScreenName } from '../../../Utils/helper';
import Cookies from 'js-cookie';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { fireEvent } from '../../../Utils/fireEvent';

export default function CarouselPopup(props) {
  const {
    productImages,
    location,
    selectedImageIndex,
    showPopup,
    newLocation,
    productData,
    setShowHeader,
    babyTrustUI,
  } = props;
  const selectedIndex = selectedImageIndex;
  const [showControls, setShowControls] = useState(true);
  const [reviewData, setReviewData] = useState({});
  const [
    showCarouseFeedBackBannerOnIndex,
    setShowCarouseFeedBackBannerOnIndex,
  ] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const videoPlayer = useRef(null);
  const videoIndex = useRef(null);
  const feedbackAdded = useRef(false);
  let carouselImages = [];
  const router = useRouter();

  useEffect(() => {
    if (location == 'images_by_User') {
      setReviewData(productImages[selectedIndex]);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (newLocation === 'images_by_User_carousel') {
      fireEvent({
        category: 'viewed_review_fullscreen',
        section_name: 'IMAGES_BY_USER',
        content_id: productImages[selectedImageIndex]?.id,
        screen_name: getScreenName(),
        object_id: productImages[selectedImageIndex]?.object_id,
        position: selectedImageIndex,
        sku_id: productData?.id,
        sku_name: productData?.name,
      });
    }
  }, []);

  productImages?.forEach((element, index) => {
    carouselImages.push(
      <div key={`popupImages${index}`}>
        <TransformWrapper
          initialPositionX={0}
          initialPositionY={0}
          wheelStep={0.2}
          wrapperStyle={{ width: '100%' }}
        >
          <TransformComponent
            contentStyle={{ width: '100%' }}
            wrapperStyle={{ width: '100%' }}
          >
            <CarouselPopupBackground key={`prod-imgs-${index}`}>
              <img
                style={{ width: '100%' }}
                src={location == 'images_by_User' ? element.image : element}
                alt={`images by user ${index}`}
              />
            </CarouselPopupBackground>
          </TransformComponent>
        </TransformWrapper>
      </div>,
    );
  });

  const closePopupHandler = () => {
    if (newLocation === 'images_by_User_carousel') {
      showPopup(false);
    } else {
      const params = new URLSearchParams(window.location.search);
      params.delete('imageGallery');
      params.delete('productImageGallery');
      if (window?.history?.length > 2) {
        router.back();
      } else {
        router.replace(
          window.location.pathname.toString() + '?' + params,
          undefined,
          {
            scroll: false,
          },
        );
      }
    }
    if (setShowHeader) setShowHeader('0px');
  };
  let ReviewedImages = useRef([]);

  const thumbHandler = (elementIndex, seeMore) => {
    setIsPlaying(false);
    videoPlayer?.current?.pause();
    if (feedbackAdded.current) {
      ReviewedImages.current.forEach((item, index) => {
        if (item.contentType && elementIndex == index) {
          item['selectedIndex'] = elementIndex;
          if (seeMore) {
            item['seeMore'] = true;
          }
          setReviewData(item);
        }
      });
    } else {
      productImages.forEach((item, index) => {
        if (item.contentType && elementIndex == index) {
          item['selectedIndex'] = elementIndex;
          if (seeMore) {
            item['seeMore'] = true;
          }
          setReviewData(item);
        }
      });
    }
    if (newLocation === 'images_by_User_carousel') {
      Cookies.set('clicked_Image', elementIndex, '/');
    }
  };
  const setValuableFeedback = (index, ReviewId) => {
    feedbackAdded.current = true;
    productImages?.forEach((element, index) => {
      if (element?.id == ReviewId) {
        element['isReviewed'] = true;
        ReviewedImages.current.push(element);
      } else {
        ReviewedImages.current.push(element);
      }
    });
    setShowCarouseFeedBackBannerOnIndex(index);
    thumbHandler(index, false);
  };

  const setSeeMoreOnIndexBasis = (index) => {
    thumbHandler(index, true);
  };

  return (
    <>
      {carouselImages && (
        <CarouselPopupCover newImagePopup location={'images_by_User'}>
          <CarouselCss location={'images_by_User'}>
            <CarouselPopupContainer babyTrustUI={babyTrustUI}>
              <CrossWhite
                onClick={() => closePopupHandler(true)}
                src={
                  location == 'images_by_User'
                    ? images.CrossWhite
                    : 'https://mylofamily.com/v2/static/images/Close_black.svg'
                }
                alt="popup close"
                location={'images_by_User'}
              />
              {babyTrustUI && !isDesktopUser() && (
                <div style={{ height: '70px' }}></div>
              )}
              <Carousel
                autoPlay={false}
                showThumbs={false}
                autoFocus={false}
                showIndicators={false}
                interval={100000000}
                showStatus={false}
                transitionTime={300}
                infiniteLoop={false}
                selectedItem={selectedIndex}
                onClickItem={(index) => {
                  if (videoIndex?.current == index) {
                    setShowControls(!showControls);
                  }
                }}
                onChange={(index) => {
                  thumbHandler(index);
                }}
                className={'addingclass thumbAddingClass'}
              >
                {carouselImages}
              </Carousel>
              {reviewData && location == 'images_by_User' && !babyTrustUI && (
                <UserDetailImagesByUser
                  data={reviewData}
                  carouselFeedback={true}
                  setShowCarouseFeedBackBannerOnIndex={setValuableFeedback}
                  setSeeMoreOnIndexBasis={setSeeMoreOnIndexBasis}
                />
              )}
            </CarouselPopupContainer>
          </CarouselCss>
        </CarouselPopupCover>
      )}
    </>
  );
}
